<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500">
      <a role="button" class="underline" @click.prevent="showAccProductTemplate">
        {{ accProductTemplate.name }}
      </a>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-right">
      <span class="whitespace-nowrap">{{ createdAt }}</span>
      <div>
        {{ createdAtFromNow }}
      </div>
    </td>
  </tr>
</template>
<script>
import moment from 'moment';

export default {
  inject: ['dataList'],
  props: {
    accProductTemplate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    createdAt() {
      return moment.utc(this.accProductTemplate.createdAt).local().format('YYYY-MM-DD HH:mm');
    },
    createdAtFromNow() {
      return moment.utc(this.accProductTemplate.createdAt).local().fromNow();
    },
  },
  methods: {
    showAccProductTemplate() {
      this.$modal.show({
        component: () => import('@/components/AccProductTemplateModal/Index.vue'),
        props: {
          accProductTemplateId: this.accProductTemplate.id,
        },
        on: {
          destroyed: () => {
            this.dataList.fetchList();
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
